import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const isOpenToast = ref<boolean>(false)

  const openToast = () => {
    isOpenToast.value = true
  }

  const closeToast = () => {
    isOpenToast.value = false
  }

  watch(
    () => isOpenToast.value,
    (value) => {
      if (value) {
        setTimeout(closeToast, 2000)
      }
    },
  )

  return {
    isOpenToast,
    openToast,
    closeToast,
  }
})
